import { handledGetFetch, handledPostFetch } from '../../submodules/shared/utils/api-base';

import { PATHS } from './paths';
import { buildUrl } from './url';

export const getProducts = () => handledGetFetch(buildUrl(PATHS.labProducts));

export const getProductList = () => handledGetFetch(buildUrl(PATHS.productAccess));

export const postProductAccess = (payload) => handledPostFetch(buildUrl(PATHS.productAccessById(payload.id)), payload);
